import React from 'react';
import TemplateModal from 'pages/site/clipping/resume/TemplateModal';

export default [
  {
    Header: 'Agendado',
    id: 'state',
    show: true,
    width: 100,
    accessor: d => {
      if (d.state === 'ACTIVE') return 'Sim';
      if (d.state === 'CANCELLED') return 'Cancelado';
      if (d.state === 'COMPLETED') return 'Não';
    },
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  {
    Header: 'Disponibilização',
    id: 'release_date',
    show: false,
    width: 100,
    accessor: d => {
      return `${d.release_date.substring(8, 10)}/${d.release_date.substring(
        5,
        7
      )}/${d.release_date.substring(0, 4)}`;
    },
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  {
    Header: 'Publicação',
    id: 'start_date',
    show: false,
    width: 100,
    accessor: d => {
      return `${d.start_date.substring(8, 10)}/${d.start_date.substring(
        5,
        7
      )}/${d.start_date.substring(0, 4)}`;
    },
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  {
    Header: 'Início',
    id: 'count_date',
    show: true,
    width: 100,
    accessor: d => {
      return `${d.count_start_date.substring(
        8,
        10
      )}/${d.count_start_date.substring(5, 7)}/${d.count_start_date.substring(
        0,
        4
      )}`;
    },
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  {
    Header: 'Término',
    id: 'end_date',
    show: true,
    width: 100,
    accessor: d => {
      return `${d.end_date.substring(8, 10)}/${d.end_date.substring(
        5,
        7
      )}/${d.end_date.substring(0, 4)}`;
    },
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  {
    Header: 'Prosseguimento',
    id: 'action',
    show: true,
    width: 200,
    accessor: d => d.Actions_action,
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  {
    Header: 'N.º Processo',
    id: 'process_number',
    show: true,
    width: 220,
    accessor: d => d.process_number,
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  {
    Header: 'Origem',
    id: 'source',
    show: false,
    width: 150,
    accessor: d => d.Sources_source,
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  {
    Header: 'Vara',
    id: 'court',
    show: false,
    width: 180,
    accessor: d => d.Courts_court,
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  {
    Header: 'Reclamante',
    id: 'claimant',
    show: true,
    width: 180,
    accessor: d =>
      d.parties.map(party => {
        if (party.party_type_id === 1) return party.name;
      }),
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  {
    Header: 'Advogado Reclamante',
    id: 'claimantLawyer',
    show: true,
    width: 180,
    accessor: d =>
      d.parties.map(party => {
        if (party.party_type_id === 3) return party.name;
      }),
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  {
    Header: 'N.° OAB Advº Rte',
    id: 'claimantLawyerOAB',
    show: false,
    width: 110,
    accessor: d =>
      d.parties.map(party => {
        if (party.party_type_id === 3) return party.lawyer_oab;
      }),
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  {
    Header: 'Reclamado',
    id: 'claimed',
    show: false,
    width: 180,
    accessor: d =>
      d.parties.map(party => {
        if (party.party_type_id === 2) return party.name;
      }),
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  {
    Header: 'Advogado Reclamado',
    id: 'claimedLawyer',
    show: false,
    width: 180,
    accessor: d =>
      d.parties.map(party => {
        if (party.party_type_id === 4) return party.name;
      }),
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  {
    Header: 'N.º OAB Advº Rdo',
    id: 'claimedLawyerOAB',
    show: false,
    width: 110,
    accessor: d =>
      d.parties.map(party => {
        if (party.party_type_id === 4) return party.lawyer_oab;
      }),
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  {
    Header: 'Descrição',
    id: 'description',
    show: true,
    width: 200,
    accessor: d => d.observation,
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  {
    Header: 'Recorte',
    id: 'clipping',
    show: false,
    width: 200,
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    accessor: d => d.clipping,
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  {
    Header: 'Criação do Evento',
    id: 'created_at',
    show: true,
    width: 200,
    accessor: d => {
      return `${d.created_at.substring(8, 10)}/${d.created_at.substring(
        5,
        7
      )}/${d.created_at.substring(0, 4)}`;
    },
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  {
    Header: 'Minuta',
    id: 'protocol',
    show: true,
    width: 100,
    accessor: d => {
      return <TemplateModal idAction={d.action_id} processObject={d} />;
    },
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
];
